"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectCollectionSummary = void 0;
const base_1 = require("./base");
class IkeObjectCollectionSummary extends base_1.IkeRestObject {
    constructor() {
        super();
        this.className = 'CollectionSummary';
        this.actionName = 'collection.summary';
        this.cacheKeys['uuid'] = true;
        this.cacheKeys['revision'] = true;
        this.cacheKeys['collectionId'] = true;
    }
    updateCache(key, result, rest) {
        super.updateCache(key, result, rest);
        this.cacheIfLatest('uuid', result, rest);
        this.cacheIfLatest('revision', result, rest);
        this.cacheIfLatest('collectionId', result, rest);
    }
}
exports.IkeObjectCollectionSummary = IkeObjectCollectionSummary;
//# sourceMappingURL=collection.summary.object.js.map